import LangEnum from '../lang/LangEnum';
import { AvailabilityEnum, CompactAvailability } from '../modules/products/ProductTypes';
import { TranslateType } from '../modules/translation/translationContext.types';

interface GetAvailabilityLabelParams {
  availability: AvailabilityEnum | CompactAvailability;
  deliveryWindowName: string | null;
  translate: TranslateType;
}

export const getAvailabilityLabel = ({
  availability,
  deliveryWindowName,
  translate,
}: GetAvailabilityLabelParams) => {
  const availabilityLabelMapper = {
    [AvailabilityEnum.READY_FOR_DELIVERY]: translate(LangEnum.GLOBAL_READY_FOR_DELIVERY),
    [AvailabilityEnum.FUTURE_STOCK]:
      deliveryWindowName?.toLowerCase() || translate(LangEnum.GLOBAL_TO_DEFINE_DELIVERY_SHORT),
    [CompactAvailability.PRE_ORDER]:
      deliveryWindowName?.toLowerCase() || translate(LangEnum.GLOBAL_TO_DEFINE_DELIVERY_SHORT),
    [AvailabilityEnum.INFINITE_PRE_ORDER]:
      deliveryWindowName?.toLowerCase() || translate(LangEnum.GLOBAL_TO_DEFINE_DELIVERY_SHORT),
    [AvailabilityEnum.MATERIAL_PRE_ORDER]:
      deliveryWindowName?.toLowerCase() || translate(LangEnum.GLOBAL_TO_DEFINE_DELIVERY_SHORT),
  };

  return (
    availabilityLabelMapper[availability as keyof typeof availabilityLabelMapper] ||
    translate(LangEnum.GLOBAL_TO_DEFINE_DELIVERY_SHORT)
  );
};
